import { useEffect, useState } from "react";

export type FacilityType = { id: number; name: string };

/** The facility types sign-up offers, in display order; empty until loaded.
 * Fetched once `enabled` is true. */
export const useFacilityTypes = (enabled = true) => {
  const [types, setTypes] = useState<FacilityType[]>([]);
  useEffect(() => {
    if (!enabled) return;
    fetch("/graphql/provider-signup/facility-types")
      .then((response) => response.json())
      .then(({ data }: { data: FacilityType[] }) => setTypes(data))
      .catch(console.error);
  }, [enabled]);
  return types;
};
